import React, { PureComponent } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { CLOUDINARY_THUMB } from "../../helpers/cloudinaryConstants";

const Comment = ({ comment, user }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid #eee"
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className="avatar">
        <img
          src={`${CLOUDINARY_THUMB}/${user.avatar.image.cloudinaryId}`}
          className="img-avatar"
          alt={user.username}
        />
      </div>
      <div style={{ fontWeight: "bold", marginLeft: 8 }}>{user.username}</div>
    </div>

    <div className="comment" style={{ marginLeft: 10 }}>
      {comment}
    </div>
  </div>
);

class FlagCommentsModal extends PureComponent {
  renderComments() {
    return this.props.flags.map(flag => (
      <Comment key={flag.id} user={flag.author} comment={flag.comment} />
    ));
  }
  render() {
    return this.props.flags ? (
      <Modal
        isOpen={this.props.isOpen}
        className={this.props.className}
        toggle={this.toggle}
      >
        <ModalHeader toggle={this.props.close}>Comments</ModalHeader>
        <ModalBody>{this.renderComments()}</ModalBody>
      </Modal>
    ) : null;
  }
}

export default FlagCommentsModal;



// WEBPACK FOOTER //
// ./src/views/Components/FlagCommentsModal.js